"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.t = void 0;
const language = typeof window !== 'undefined'
    ? (window.navigator.userLanguage || window.navigator.language).toLowerCase()
    : 'en--us';
const enUs = {
    yes: 'Yes',
    no: 'No',
    'popup-window-hint': 'Attempt to open Qubic to complete the action. Do you want to proceed ?',
};
const zhTw = {
    yes: '是',
    no: '否',
    'popup-window-hint': '會在新視窗開啟以完成操作，是否繼續？',
};
const locales = {
    'en-us': enUs,
    'zh-tw': zhTw,
};
exports.t = (key) => {
    return language in locales ? locales[language][key] : locales['en-us'][key];
};
